import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import PrivateRoute from './auth/PrivateRoute';
import { useMediaQuery } from '@mui/material';
import AppLayout from './layout/AppLayout';
import AppLayoutMobile from './layout/AppLayoutMobile';

import LoginPage from './pages/login/LoginPage';
import RegisterPage from './pages/register/RegisterPage';
import ForbiddenPage from './pages/ForbiddenPage';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';
import TokenExpiredPage from './pages/TokenExpiredPage';

import DashboardStudioPage from './pages/dashboard/DashboardStudioPage';
import DashboardContribuentePage from './pages/dashboard/DashboardContribuentePage';
import DashboardAdmin from './pages/dashboard/DashboardAdminPage';

import UtentiListPage from './pages/utenti/UtentiListPage';
import UtenteDetailPage from './pages/utenti/UtenteDetailPage';
import UtenteCreatePage from './pages/utenti/UtenteCreatePage';
import UtenteEditPage from './pages/utenti/UtenteEditPage';

import StudiListPage from './pages/studi/StudiListPage';
import StudioDetailPage from './pages/studi/StudioDetailPage';
import StudioCreatePage from './pages/studi/StudioCreatePage';
import StudioEditPage from './pages/studi/StudioEditPage';

import ContribuentiListPage from './pages/contribuenti/ContribuentiListPage';
import ContribuenteDetailPage from './pages/contribuenti/ContribuenteDetailPage';
import ContribuenteEditPage from './pages/contribuenti/ContribuenteEditPage';
import ContribuenteCreatePage from './pages/contribuenti/ContribuenteCreatePage';
import ReportContribuentePage from './pages/reports/ReportContribuentePage';

import DocumentiListPage from './pages/documenti/DocumentiListPage';
import DocumentoDetailPage from './pages/documenti/DocumentoDetailPage';
import DocumentoEditPage from './pages/documenti/DocumentoEditPage';
import DocumentoCreatePage from './pages/documenti/DocumentoCreatePage';
import DocumentoUploadPage from './pages/documenti/DocumentoUploadPage';

import ScadenzaCreatePage from './pages/scadenze/ScadenzaCreatePage';
import ScadenzaEditPage from './pages/scadenze/ScadenzaEditPage';
import ScadenzaDetailPage from './pages/scadenze/ScadenzaDetailPage';

import ContrattoCreatePage from './pages/contratti/ContrattoCreatePage';
import ContrattoDetailPage from './pages/contratti/ContrattoDetailPage';
import ContrattoEditPage from './pages/contratti/ContrattoEditPage';
import PagamentoCreatePage from './pages/pagamenti/PagamentoCreatePage';
import PagamentoEditPage from './pages/pagamenti/PagamentoEditPage';
import ConsensoPage from './pages/consenso/ConsensoPage';
import DeskStudioLandingPage from './pages/sitopubblico/DeskStudioLandingPage';
import PrivacyPolicy from './pages/sitopubblico/PrivacyPolicy';
import TermsAndConditions from './pages/sitopubblico/TermsAndConditions';
import DemoWidgetPage from './pages/sitopubblico/DemoWidgetPage';
import DemoRequestPage from './pages/sitopubblico/DemoRequestPage';
import AuditListPage from './pages/audit/AuditListPage';
import RichiesteDemoListPage from './pages/richiestedemo/RichiesteDemoListPage';
import FascicoloDetailPage from './pages/fascicoli/FascicoloDetailPage';
import CreateDocumentoFascicoloPage from './pages/fascicoli/CreateDocumentoFascicoloPage';
import RichiestaCreatePage from './pages/fascicoli/RichiestaCreatePage';
import NotificheListPage from './pages/notifiche/NotificheListPage';
import ErrorBoundary from './components/ErrorBoundary';

import { NotificationProvider } from './context/NotificationProvider';
import NotificheBadge from './components/NotificheBadge';
import ForgotPasswordPage from './pages/login/ForgotPasswordPage';
import ResetPasswordPage from './pages/login/ResetPasswordPage';
import NotFoundPage from './pages/NotFoundPage';

import TicketListPage from './pages/tickets/TicketListPage';
import TicketDetailPage from './pages/tickets/TicketDetailPage';
import TicketCreatePage from './pages/tickets/TicketCreatePage';

import ChatListPage from './pages/chat/ChatListPage';
import ChatRoomPage from './pages/chat/ChatRoomPage';
import ChatRoomCreatePage from './pages/chat/ChatRoomCreatePage';
import { initGA, trackPageView } from './analytics';

function App() {
const isMobile = useMediaQuery('(max-width:768px)');
  useEffect(() => {
    initGA(); // inizializza GA una volta
  }, []);

  useEffect(() => {
    trackPageView(location.pathname); // traccia ogni cambio pagina
  }, [location]);
  return (
    <AuthProvider>
    <NotificationProvider>
      <BrowserRouter>
        <Routes>
          {/* Rotte pubbliche */}
          <Route path="/" element={<DeskStudioLandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forbidden" element={<ForbiddenPage />} />
          <Route path="/token-expired" element={<TokenExpiredPage />} />
          <Route path="/sitopubblico/demowidget" element={<DemoWidgetPage />} />
          <Route path="/sitopubblico/demorequest" element={<DemoRequestPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/pagamenti/success" element={<SuccessPage />} />
          <Route path="/pagamenti/cancel" element={<CancelPage />} />

          <Route path="/consenso" element={
                    <ConsensoPage />
          } />
          <Route path="*" element={<NotFoundPage />} />
          {/* Rotte protette con layout */}
          <Route element={isMobile ? <AppLayoutMobile /> : <AppLayout />}>
            {/* Dashboard */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute roles={['CONTRIBUENTE','STUDIO', 'ADMIN']}>
                  <DashboardAdmin />
                </PrivateRoute>
              }
            />

          {/* Richieste Demo */}
          <Route
            path="/richiestedemo"
            element={
              <PrivateRoute roles={['ADMIN']}>
                <RichiesteDemoListPage />
              </PrivateRoute>
            }
          />
        <Route
          path="/richiestedemo/:id"
          element={
            <PrivateRoute roles={['ADMIN']}>
              <RichiesteDemoListPage />
            </PrivateRoute>
          }
        />
          {/* Fascicolo contribuenti */}

            <Route path="/fascicolo/me"
                 element={
                       <PrivateRoute roles={['CONTRIBUENTE']}>
                       <FascicoloDetailPage />
                       </PrivateRoute>
                       }
            />
          <Route path="/contribuente/:id/fascicolo"
                  element={
                     <PrivateRoute roles={['STUDIO', 'ADMIN']}>
                        <FascicoloDetailPage />
                      </PrivateRoute>
                      }
           />

          {/* Creazione documento fascicolo */}
          <Route path="/fascicolo/:fascicoloId/documento/create"
              element={
                  <PrivateRoute roles={['STUDIO', 'ADMIN','CONTRIBUENTE']}>
                  <CreateDocumentoFascicoloPage />
                  </PrivateRoute>
              }
          />

            <Route path="/notifiche"
                element={
                    <PrivateRoute roles={['STUDIO', 'ADMIN','CONTRIBUENTE']}>
                    <NotificheListPage />
                    </PrivateRoute>
                }
            />

            <Route path="/fascicolo/:fascicoloId/richieste/create"
                element={
                    <PrivateRoute roles={['STUDIO', 'ADMIN','CONTRIBUENTE']}>
                    <RichiestaCreatePage />
                    </PrivateRoute>
                }
            />


            <Route
              path="/dashboard/studio/:id"
              element={
                <PrivateRoute roles={['STUDIO']}>
                  <DashboardStudioPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard/contribuente/:id"
              element={
                <PrivateRoute roles={['CONTRIBUENTE']}>
                  <DashboardContribuentePage />
                </PrivateRoute>
              }
            />

            {/* Users */}
            <Route
              path="/users"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <UtentiListPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/users/create"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <UtenteCreatePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/users/:id"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <UtenteDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/users/:id/edit"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <UtenteEditPage />
                </PrivateRoute>
              }
            />
            <Route
               path="/contratti/create"
                          element={
                            <PrivateRoute roles={['ADMIN']}>
                              <ContrattoCreatePage />
                            </PrivateRoute>
                          }
                        />
            <Route
               path="/contratti/:id"
                          element={
                            <PrivateRoute roles={['ADMIN','STUDIO','CONTRIBUENTE']}>
                              <ContrattoDetailPage />
                            </PrivateRoute>
                          }
            />
            <Route
               path="/contratti/:id/edit"
                          element={
                            <PrivateRoute roles={['ADMIN']}>
                              <ContrattoEditPage />
                            </PrivateRoute>
                          }
            />
            <Route
               path="/pagamenti/create"
                          element={
                            <PrivateRoute roles={['ADMIN']}>
                              <PagamentoCreatePage />
                            </PrivateRoute>
                          }
            />
            <Route
               path="/pagamenti/edit/:id"
                          element={
                            <PrivateRoute roles={['ADMIN','CONTRIBUENTE','STUDIO']}>
                              <PagamentoEditPage />
                            </PrivateRoute>
                          }
            />
            {/* Studi */}
            <Route
              path="/studi"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <StudiListPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/studi/:id"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <StudioDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/studi/edit/:id"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <StudioEditPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/studi/create"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <StudioCreatePage />
                </PrivateRoute>
              }
            />

            {/* Audit */}
            <Route
              path="/audit"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <AuditListPage />
                </PrivateRoute>
              }
            />
            {/* Contribuenti */}
            <Route
              path="/contribuenti"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <ContribuentiListPage />
                </PrivateRoute>
              }
            />
                <Route
                  path="/contribuenti/bystudio/:id"
                  element={
                    <PrivateRoute roles={['STUDIO']}>
                      <ContribuentiListPage />
                    </PrivateRoute>
                  }
                />
            <Route
              path="/contribuenti/:id"
              element={
                <PrivateRoute roles={['STUDIO','ADMIN']}>
                  <ContribuenteDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/contribuenti/report/:id"
              element={
                <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                  <ReportContribuentePage />
                </PrivateRoute>
              }
            />
            <Route
            path="/contribuenti/edit/:id"
              element={
                <PrivateRoute roles={['STUDIO','ADMIN']}>
               <ContribuenteEditPage />
               </PrivateRoute>
             }
            />
            <Route
            path="/contribuenti/create"
              element={
                <PrivateRoute roles={['STUDIO', 'ADMIN']}>
               <ContribuenteCreatePage />
               </PrivateRoute>
             }
            />
            <Route
            path="/contribuenti/createfromuser/:userId"
              element={
                <PrivateRoute roles={['STUDIO', 'ADMIN']}>
               <ContribuenteCreatePage />
               </PrivateRoute>
             }
            />
            <Route
              path="/documenti/:id/upload"
              element={
                <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                  <DocumentoUploadPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/documenti/nuovo/upload"
              element={
                <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                  <DocumentoUploadPage />
                </PrivateRoute>
              }
            />
             <Route
                path="/contribuenti/:contribuenteId/documenti/upload"
                element={
                  <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                    <DocumentoUploadPage />
                  </PrivateRoute>
                }
              />
          <Route
            path="/tickets"
            element={
              <PrivateRoute roles={['ADMIN','STUDIO','CONTRIBUENTE']}>
                <TicketListPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/tickets/create"
            element={
              <PrivateRoute roles={['STUDIO','CONTRIBUENTE']}>
                <TicketCreatePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/tickets/:id"
            element={
              <PrivateRoute roles={['ADMIN','STUDIO','CONTRIBUENTE']}>
                <TicketDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/chatrooms"
            element={
              <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                <ChatListPage />
              </PrivateRoute>
            }
          />
        <Route
             path="/chatroom/:id"
             element={
               <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                 <ChatRoomPage />
               </PrivateRoute>
             }
           />
        <Route
             path="/chatroomcreate"
             element={
               <PrivateRoute roles={['ADMIN']}>
                 <ChatRoomCreatePage />
               </PrivateRoute>
             }
           />
            {/* Documenti */}
            <Route
              path="/documenti"
              element={
                <PrivateRoute roles={['ADMIN']}>
                  <DocumentiListPage />
                </PrivateRoute>
              }
            />
              <Route
                path="/documenti/bycontribuente/:id"
                element={
                  <PrivateRoute roles={['CONTRIBUENTE']}>
                    <DocumentiListPage />
                  </PrivateRoute>
                }
              />
            <Route
              path="/documenti/:id"
              element={
                <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                  <DocumentoDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/documenti/edit/:id"
              element={
                <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                <DocumentoEditPage />
                </PrivateRoute>
                }
             />
            <Route
              path="/documenti/create"
              element={
                <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                <DocumentoCreatePage />
                </PrivateRoute>
                }
             />


            <Route
              path="/documenti/:documentoId/scadenze/create"
              element={
                <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                  <ScadenzaCreatePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/scadenze/edit/:id"
              element={
                <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                  <ScadenzaEditPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/scadenze/:id"
              element={
                <PrivateRoute roles={['STUDIO', 'CONTRIBUENTE', 'ADMIN']}>
                  <ScadenzaDetailPage />
                </PrivateRoute>
              }
            />
          </Route>


        </Routes>
      </BrowserRouter>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
